var map = {
	"./example": 25352,
	"./example.json": 25352,
	"./upload_right_1@2x.png": 1444,
	"./upload_right_2@2x.png": 4246,
	"./upload_right_3@2x.png": 65483,
	"./upload_wrong_1@2x.png": 13329,
	"./upload_wrong_2@2x.png": 23046,
	"./upload_wrong_3@2x.png": 16800,
	"./upload_wrong_4@2x.png": 12706,
	"./upload_wrong_5@2x.png": 71657
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 69485;